import RegiondoBookingCardBase from '../common/RegiondoBookingCardBase';
import { generateUniqueColor } from '../../../../util/colorUtil';

function BookingCardExit({ booking, renderAvailableSlots, resourceColorById }) {
  const resourceId = booking.resourceId?._id || booking.resourceId || booking.gameName;
  const resourceIdStr = resourceId != null ? String(resourceId) : null;
  const pooledColor =
    resourceIdStr && resourceColorById instanceof Map ? resourceColorById.get(resourceIdStr) : null;
  const color = resourceIdStr ? pooledColor || generateUniqueColor(resourceIdStr) : '#ffffff';

  return (
    <RegiondoBookingCardBase
      booking={booking}
      color={color}
      renderAvailableSlots={renderAvailableSlots}
    />
  );
}

export default BookingCardExit;
